import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Column } from '~common/components/column.component';
import {
  TranslationField,
  TranslationFormData,
} from '~admin/view/components/ui/form/fields/field-translation.component';
import { TextField } from '~common/components/form/field-text.component';

export interface EventMerchandiseRestrictionsFormData {
  merchText: TranslationFormData<string>[];
  merchButtonText: TranslationFormData<string>[];
  merchButtonUrl: TranslationFormData<string>[];
}

export const EventMerchandiseRestrictions: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <TranslationField
        name={`merchText`}
        label={t('createEvent.eventDetails.restrictions.merch.text')}
        render={(renderProps): ReactNode => <TextField multiline {...renderProps} />}
      />
      <TranslationField
        name={`merchButtonText`}
        label={t('createEvent.eventDetails.restrictions.merch.buttonText')}
        render={(renderProps): ReactNode => <TextField {...renderProps} />}
      />
      <TranslationField
        name={`merchButtonUrl`}
        label={t('createEvent.eventDetails.restrictions.merch.buttonUrl')}
        render={(renderProps): ReactNode => <TextField {...renderProps} />}
      />
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;

  & > :not(:first-child) {
    margin-top: 24px;
  }
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-restrictions/event-merchandise-restrictions.component.tsx